(function() {
    var errorContainer = '[data-micro-trade-in-error]',
        errorContent = errorContainer + ' [data-message]',
        errorTimeout = 3000;
    var microTradeInComponent = {
        storageKey: 'stored-trade-in',
        selectors: {
            observerDataAttribute: '[data-micro-trade-in-component]',
            saveButton: '[data-micro-trade-in-component-save-button]',
            modelId: 'data-model-id',
            deviceName: 'data-device-name',
            offer: 'data-offer',
            quotedPrice: 'data-quoted-price',
            network: 'data-network',
            productConditionTab: '[data-condition-tab]',
            productValueTab: '[data-value-tab]',
            confirmationTab: '[data-confirmation-tab]',
            searchWrapper: '[data-search-wrapper]',
            getAnotherQuoteButton: '[data-get-another-quote-button]',
            getAnotherQuoteButtonContainer: '[data-get-another-quote-button-container]',
            clearTradeInButton: '[data-clear-trade-in-button]',
            spinner: '[data-spinner]',
            ctaCopy: '[data-cta-copy]',
            switchAffiliatePlanBtn: '[data-upsell-link]',
        },
        routes: {
            initialInject: '/beta/micro-trade-in/index'
        },
        init: function() {
            if (parseInt(localStorage.getItem('basketTrade')) == 1) {
                let lineValue = $('.basket-item-remove').first().find('input[name="line"]').val();
                const savedData = JSON.parse(localStorage.getItem('accessoryData'));
                if (savedData && savedData.length > 0) {
                    // loader start
                    savedData.forEach((item) => {
                        // alert(item.dealId +','+ item.giftCode+','+ item.itemType+','+ lineValue);
                        microTradeInComponent.addToBasket(item.dealId, item.giftCode, item.itemType, lineValue);
                    });
                    microTradeInComponent.updateBasketSummary();
                    localStorage.removeItem('accessoryData');
                    localStorage.removeItem('basketTrade');
                    // loader end
                }
            }
            if (window.isUpsellEnabled) {
                localStorage.setItem('affiliateUpsellUrl', window.location.search);
            }
            if (parseInt(localStorage.getItem('affiliateUpsell')) == 1) {
                let lineValue = $('.basket-item-remove').first().find('input[name="line"]').val();
                const savedData = JSON.parse(localStorage.getItem('accessoryData'));
                if (savedData && savedData.length > 0) {
                    // loader start
                    savedData.forEach((item) => {
                        // chechk upsell deal has same accessories
                        let $button = $('.accessory-add-to-basket[data-deal-id="' + item.dealId + '"][data-gift-code="' + item.giftCode + '"]');
                        if ($button.length > 0) {
                            microTradeInComponent.addToBasket(item.dealId, item.giftCode, item.itemType, lineValue);
                        }
                    });
                    microTradeInComponent.updateBasketSummary();
                    localStorage.removeItem('accessoryData');
                    localStorage.removeItem('affiliateUpsell');
                    // loader end
                }
            }

            var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver,
                observer = new MutationObserver(function(mutations, observer) {
                    if (document.querySelector(microTradeInComponent.selectors.observerDataAttribute)) {
                        microTradeInComponent.inject();
                        observer.disconnect();
                    }
                });

            observer.observe(document.querySelector('body'), {
                childList: true,
                attributes: true,
                subtree: true,
            });

            $(document)
                .on('click', microTradeInComponent.selectors.saveButton, microTradeInComponent.saveTradein)
                .on('click', microTradeInComponent.selectors.getAnotherQuoteButton, microTradeInComponent.inject)
                .on('click', microTradeInComponent.selectors.switchAffiliatePlanBtn, microTradeInComponent.saveAffiliateUpsaleDeal);

        },
        inject: function() {
            $.ajax({
                url: microTradeInComponent.routes.initialInject,
                error: function() {
                    $(microTradeInComponent.selectors.observerDataAttribute).remove();
                },
                success: function(response) {
                    $(microTradeInComponent.selectors.observerDataAttribute).html(response);
                }
            });
        },
        // functions for URL parameter handling
        storeUrlParameters: function() {
            const url = new URL(window.location.href);
            var params = new URLSearchParams(url.search);

            if (params.has('affiliate')) {
                return localStorage.getItem('retainedAffiliateParams');
            }
            return '';
        },

        appendParametersToUrl: function(url, parameters) {
            if (!parameters || parameters.length === 0) {
                return url;
            }
            const urlObj = url + '?' + parameters;
            return urlObj.toString();
        },

        saveTradein: function() {
            localStorage.setItem('tradeInSource', 'Basket');
            var $button = $(this);
            var lineValue = $('.basket-item-remove').first().find('input[name="line"]').val(),
                dealId = $('.basket-item').first().data('deal-id'),
                variation = $('.basket-item').first().data('variation'),
                modelId = $button.attr(microTradeInComponent.selectors.modelId),
                network = $button.attr(microTradeInComponent.selectors.network),
                deviceName = $button.attr(microTradeInComponent.selectors.deviceName),
                offer = $button.attr(microTradeInComponent.selectors.offer),
                quotedPrice = $button.attr(microTradeInComponent.selectors.quotedPrice);
            if (variation == '') {
                variation = 'NA';
            }
            let existingData = [];
            $('.accessory-add-to-basket[data-remove-accessory]').each(function() {
                const accessoryData = {
                    'dealId': $(this).data('dealId'),
                    'giftCode': $(this).data('giftCode'),
                    'itemType': 'deal'
                };
                existingData.push(accessoryData);
            });
            localStorage.setItem('accessoryData', JSON.stringify(existingData));

            // Store URL parameters using the new utility function
            const urlParams = microTradeInComponent.storeUrlParameters();

            // loader start
            $.ajax({
                url: '/beta/micro-trade-in/stored-trade-in',
                method: 'POST',
                data: {
                    'lineValue': lineValue,
                    'modelId': modelId,
                    'deviceName': deviceName,
                    'offer': offer,
                    'quotedPrice': quotedPrice,
                    'network': network
                },
                dataType: 'json',
                success: function(response) {
                    if (response.success) {
                        localStorage.setItem('basketTrade', 1);

                        // Build redirect URL with stored parameters
                        let redirectUrl = '/beta/add-with-trade-in/' + dealId + '/' + variation + '/' + modelId + '/' + offer;
                        redirectUrl = microTradeInComponent.appendParametersToUrl(redirectUrl, urlParams);

                        window.location.href = redirectUrl;
                    } else {
                        $(errorContent).html(response.message);
                        $(errorContainer).slideDown().delay(errorTimeout).slideUp();
                        console.error('Error:', response.log);
                    }
                },
                error: function(xhr, status, error) {
                    console.error('Error:', status, error);
                }
            });

        },
        addToBasket: function(elementDealId, elementGiftCode, itemType, elementParentId) {
            const $button = $('.accessory-add-to-basket[data-deal-id="' + elementDealId + '"]');
            var $element = $($button[0]),
                $elementInstances = $('[data-buy-accessory][data-deal-id="' + elementDealId + '"][data-parent-id="' + elementParentId + '"]'),
                activeSlideIndex = $element.closest('.swiper-wrapper').children('.swiper-slide-active').prevAll().length;
            $element.toggleClass('btn-gray-shade-2', true);
            $element.toggleClass('btn-erminto', false);
            $.ajax({
                type: 'POST',
                url: '/beta/ajax/add-to-basket',
                async: false,
                data: {
                    'dealId': elementDealId,
                    'giftCode': elementGiftCode,
                    'itemType': itemType,
                    'parentId': elementParentId,
                },
                beforeSend: function() {
                    microTradeInComponent.setCallToActionComponents($elementInstances, true, 'Adding...', false);
                },
                success: function() {
                    microTradeInComponent.setCallToActionComponents($elementInstances, false, 'Remove', true);
                    $elementInstances.attr('data-remove-accessory', '');
                    $elementInstances.attr('data-buy-accessory', null);
                },
                error: function() {
                    microTradeInComponent.setCallToActionComponents($elementInstances, false, 'Add to basket', true);
                    $elementInstances.attr('data-remove-accessory', '');
                    $elementInstances.attr('data-buy-accessory', null);
                },
                complete: function() {
                    microTradeInComponent.updateFullBasketContent(activeSlideIndex);
                },
                dataType: 'json'
            });
        },
        setCallToActionComponents: function($element, disabled, ctaCopy, hideSpinner) {
            setTimeout(function() {
                disabled ? $element.attr('disabled', true) : $element.removeAttr('disabled');
            }, (disabled ? 0 : 1000));

            $element.find(microTradeInComponent.selectors.ctaCopy).html(ctaCopy);
            $element.find(microTradeInComponent.selectors.spinner).toggleClass('hide', hideSpinner);
        },
        updateBasketSummary: function() {
            $.ajax({
                type: 'POST',
                url: '/beta/ajax/fetch-basket-summary',
                async: false,
                data: {
                    'code': $('div[data-basket-summary-small]').data('code')
                },
                success: function(response) {
                    $('div[data-basket-summary-small]').replaceWith(response);
                },
                dataType: 'html'
            });
        },
        updateFullBasketContent: function(activeSlideIndex) {
            $.ajax({
                type: 'POST',
                url: '/beta/ajax/fetch-basket-full',
                async: false,
                data: {
                    'code': $('div[data-basket-summary-full]').data('code')
                },
                success: function(response) {
                    $('div[data-basket-summary-full]').replaceWith(response);
                },
                complete: function() {
                    if (typeof activeSlideIndex !== 'undefined') {
                        initAccessorySwiper(activeSlideIndex);
                    }
                },
                dataType: 'html'
            });
        },
        saveAffiliateUpsaleDeal: function() {
            var $button = $(this);
            let dealId = $button.data('deal-id');
            let affiliateUpsellDealId = $button.data('affiliate-upsell-deal-id');
            let affiliateUpsellDealGiftCode = $button.data('affiliate-upsell-deal-giftcode');
            let affiliateUrl = localStorage.getItem('affiliateUpsellUrl');
            let lineValue = $('.basket-item[data-deal-id="' + dealId + '"]').find('.basket-item-remove input[name="line"]').val();
            if (affiliateUpsellDealGiftCode == '' || typeof affiliateUpsellDealGiftCode === 'undefined' || affiliateUpsellDealGiftCode === null) {
                affiliateUpsellDealGiftCode = 'NA';
            }
            let existingData = [];
            $('.accessory-add-to-basket[data-remove-accessory]').each(function() {
                const accessoryData = {
                    'dealId': $(this).data('dealId'),
                    'giftCode': $(this).data('giftCode'),
                    'itemType': 'deal'
                };
                existingData.push(accessoryData);
            });
            localStorage.setItem('accessoryData', JSON.stringify(existingData));

            // alert('deal id: ' + dealId + ', Upsell DealId: ' + affiliateUpsellDealId + ', Upsell Giftcode: ' + affiliateUpsellDealGiftCode + ', lineValue: ' + lineValue);

            $.ajax({
                url: '/beta/micro-trade-in/removeCurrentDeal',
                method: 'POST',
                data: {
                    'lineValue': lineValue
                },
                dataType: 'json',
                success: function(response) {
                    if (response.success) {
                        localStorage.setItem('affiliateUpsell', 1);
                        window.location.href = '/beta/buy/' + affiliateUpsellDealId + '/' + affiliateUpsellDealGiftCode + affiliateUrl;
                    } else {
                        console.error('Error:', response.log);
                    }
                },
                error: function(xhr, status, error) {
                    console.error('Error:', status, error);
                }
            });
        }

    };

    function initAccessorySwiper(activeSlideIndex) {
        const accessorySwiper = new Swiper('.accessory-swiper', {
            freeMode: false,
            autoplay: false,
            speed: 750,
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 15,
            navigation: {
                nextEl: '[data-accessory-next]',
                prevEl: '[data-accessory-prev]',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets'
            }
        });
        if (typeof activeSlideIndex !== 'undefined') {
            accessorySwiper.slideTo(activeSlideIndex, 0, false);
        }
    }

    microTradeInComponent.init();
})($);

